import { render } from "./ProfileLayoutSharp.vue?vue&type=template&id=79b39058&scoped=true"
import script from "./ProfileLayoutSharp.vue?vue&type=script&lang=js"
export * from "./ProfileLayoutSharp.vue?vue&type=script&lang=js"

import "./ProfileLayoutSharp.vue?vue&type=style&index=0&id=79b39058&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b39058"]])

export default __exports__